<template>
  <div>
    <List
      v-model="loading"
      :finished="finished"
      finished-text="没有更多数据了"
      @load="onLoad"
    >
      <div class="list-box" v-for="(item, index) in list" :key="index">
        <!-- @click.stop="goPage(item)" -->
        <div class="l-l">
          <img :src="item.avatar" @click="goto(item)" />
          <div class="name">{{ item.username }}</div>
        </div>
        <div
          class="btn"
          @click.stop="showPopup(item)"
          v-if="type == 1 || (type == 2 && item.isFollow == 1)"
        >
          取消关注
        </div>
        <div
          class="btn-f"
          @click="handleClick(item)"
          v-if="type == 2 && item.isFollow == 0"
        >
          关注
        </div>
      </div>
    </List>

    <Popup v-model="show" position="bottom" :round="true">
      <div class="pop-title">确定不再关注？</div>
      <div class="pop-sure" @click="handleClick('')">确定</div>
      <div class="pop-cancel" @click="show = false">取消</div>
    </Popup>

    
  </div>
</template>
<script>
import { List, Popup } from "vant";
export default {
  name: "focus",
  props: {},
  components: { List, Popup },

  data() {
    return {
      list: [],
      page: 1,
      finished: false,
      loading: false,
      show: false,
      item: {},
      type: 1,
      closeShareMask:false
    };
  },
  created() {
    this.type = this.$route.query.type;
  },
  methods: {
    goto(item){
      // console.log(item);
      if(item.is_teacher == 1){
        this.$router.push({path:'/teacherDetails',query:{id:item.tid}})
      }else{
        this.Toast('该用户没有主页')
      }
    },
    getList() {
      this.api.fansList({ page: this.page, type: this.type }).then((res) => {
        if (this.page == 1) {
          this.list = [];
        }
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    showPopup(item) {
      this.show = true;
      this.item = item;
    },
    handleClick(data) {
      let id = data ? data.id : this.item.id;
      this.api.follow({ id: id }).then(() => {
        if (data) {
          this.Toast.success("关注成功");
        } else {
          this.Toast("取消成功");
        }

        this.show = false;
        this.page = 1;
        this.getList();
      });
    },

    // goPage(item) {
    //   if (this.type == 1) return;
    // this.$router.push({ path: '/userpage', query: { id: item.id } })
    // },

    onLoad() {
      this.getList();
      this.page++;
    },
  },
};
</script>
<style lang="less" scoped>
.list-box {
  padding: 0.3rem 0;
  margin: 0 0.4rem;
  border-bottom: 1px solid #e3e3e3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .l-l {
    display: flex;
    align-items: center;
    flex: 1;
    img {
      width: 1rem;
      border-radius: 50%;
      height: 1rem;
      object-fit: cover;
      margin-right: 0.2rem;
    }
    .name {
      color: #3c3d52;
      font-size: 0.32rem;
      font-weight: bold;
      width: 3.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .btn,
  .btn-f {
    color: #fff;
    background: #ddd;
    border-radius: 0.45rem;
    width: 1.5rem;
    height: 0.5rem;
    font-size: 0.28rem;
    line-height: 0.5rem;
    text-align: center;
  }
  .btn-f {
    background: #34c290;
    width: 1.2rem;
  }
}
.pop-title {
  font-size: 15px;
  color: #666;
  text-align: center;
  padding: 0.5rem 0;
}
.pop-sure,
.pop-cancel {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0.2rem 0.3rem;
  text-align: center;
  height: 1rem;
  line-height: 1rem;
}
.pop-cancel {
  background: #f2f2f2;
  border-radius: 1.5rem;
}
</style>
